import tw, { styled } from 'twin.macro';
import { ImageElement } from '@kontent-ai/gatsby-components';

export const Title = styled.p`
  ${tw`font-inter font-semi-bold`}
  ${tw`text-tag-m text-primary-p1 text-center uppercase`}
  ${tw`container`}
  ${tw`container-stack-context`}
  ${tw`mb-9`}
  span {
    ${tw`text-primary-p2`};
  }
`;

export const LogoContainer = styled.div`
  ${tw`top-0 left-0`}
  ${tw`w-full`}
  ${tw`mx-1`};
  ${tw`grid grid-cols-2 gap-4`}
`;

export const Container = styled.div<{ isCondensed: boolean }>`
  ${tw`container`}
  ${tw`container-stack-context`}
  ${tw`px-2 lg:px-0`}
  ${LogoContainer} {
    ${({ isCondensed }) => (isCondensed ? tw`md:grid-cols-6` : tw`md:grid-cols-4`)}
  }

  ${Title} {
    ${({ isCondensed }) => (isCondensed ? tw`mb-4` : tw`mb-9`)}
  }
`;

export const StyledSection = styled.section<{ hasColoredBackground: boolean; variant?: string }>`
  ${({ hasColoredBackground }) =>
    hasColoredBackground && tw`bg-ui-colours-ui1 lg:bg-[transparent]`};

  ${Container} {
    ${({ hasColoredBackground }) =>
      hasColoredBackground && [tw`lg:px-5 lg:py-4`, tw`bg-ui-colours-ui1`, tw`rounded-2xl`]};
  }
`;

export const LogoItem = styled.li`
  ${tw`list-none`};
`;

export const LogoItemImage = styled(ImageElement)`
  ${tw`max-h-[72px]`}
  ${tw`w-full max-w-[180px]`}
  ${tw`mx-auto`};
`;
